export default {
  not_localised: 'Dette dokument er endnu ikke tilgængeligt i dit område. Den engelske version vises.',
};
